import React from 'react';
import { useProctor } from '../../context/ProctorContext';
import { STATES } from '../../config/states';

export function StateMachineViz() {
  const { currentState, stateHistory } = useProctor();
  const stateInfo = STATES.find(s => s.id === currentState);

  // Deduplicate consecutive same states for history display
  const deduped = stateHistory.reduce<typeof stateHistory>((acc, entry) => {
    if (acc.length === 0 || acc[acc.length - 1].state !== entry.state) acc.push(entry);
    return acc;
  }, []).slice(-15);

  return (
    <div className="state-section">
      <h3>
        상태 머신 (State Machine) — {stateInfo?.label || currentState}
      </h3>
      <div className="state-grid">
        {STATES.map(s => (
          <div
            key={s.id}
            className={`state-box ${s.id} ${s.id === currentState ? 'active' : ''}`}
            style={s.id === currentState ? { background: s.color } : undefined}
          >
            {s.short} {s.label}
          </div>
        ))}
      </div>
      <div className="state-history">
        {deduped.map((h, i) => {
          const si = STATES.find(s => s.id === h.state);
          return (
            <React.Fragment key={i}>
              {i > 0 && <span className="sh-arrow">&rarr;</span>}
              <span className="state-dot" style={{ background: si?.color || '#666' }}>
                {si?.short || '?'}
              </span>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
